import { useMemo } from 'react'
import { AutomationRuleTriggersEnum } from '../enums/trigger-enum'

export const useAllowedTriggers = (
  initialTriggers: AutomationRuleTriggersEnum[] = Object.values(AutomationRuleTriggersEnum),
): AutomationRuleTriggersEnum[] => {
  const data = useMemo(() => {
    return initialTriggers.filter(trigger => {
      switch (trigger) {
        default:
          return true
      }
    })
  }, [initialTriggers])

  return data
}
